import Vue from 'vue'
import { default as api } from '@/services/api'
import { TweenMax as Tween, Power1 } from 'gsap'

export default {

  state: {
    loading: true,
    reseting: true, // first loading after changing lang before new meta is fetched
    routeChangedFromPopup: false, // self-explanatory
    animating: false,
    blocked: false,

    mainPageIntroSlide: false,
    mainPageLastSlide: false,
    mainPageSecondSlide: false,

    window: {
      scroll: 0,
      width: window.innerWidth,
      height: window.innerHeight
    },

    meta: {},
    lang: null
  },

  getters: {
    isLoading: state => state.loading,
    isReseting: state => state.reseting,
    isAnimating: state => state.animating,
    isBlocked: state => state.blocked,
    window: state => state.window,
    meta: state => state.meta,
    pages: state => state.meta.pages,
    isMobile: state => state.window.width < 768
  },

  mutations: {
    // Common data

    setMeta: (state, data) => {
      state.meta = data
    },

    setLanguage: (state, lang) => {
      state.lang = lang
      Vue.i18n.set(lang)
    },

    // Window events

    resize: (state, { width, height }) => {
      state.window.width = width
      state.window.height = height
    },

    scroll: (state, scroll) => {
      state.window.scroll = scroll
    },

    // Loading

    startLoading: (state, reseting) => {
      state.loading = true

      if (reseting) state.reseting = true
    },

    endLoading: (state) => {
      state.loading = false
      state.reseting = false
    },

    // Animation

    popupAnimationStart: (state) => {
      state.animating = true
    },

    popupAnimationEnd: (state) => {
      state.animating = false
    },

    // Block

    block: (state) => {
      state.blocked = true
    },

    unblock: (state) => {
      state.blocked = false
    },

    // Other

    setMainPageIntroSlide: (state, { current, total }) => {
      state.mainPageIntroSlide = current === 0;
      state.mainPageSecondSlide = current === 2;
      state.mainPageLastSlide = current === total + 1
    }
  },

  actions: {
    fetchMeta: async ({ commit, state }, lang = 'ua') => {
      const response = await api.meta.get(lang);
      const data = response.data;
      let i =0;
      const locale = data.keys.reduce((locale, item) => {
        locale[item.key] = item.value;
        return locale
      }, {})



      Vue.i18n.add(state.lang, locale)
      commit('setMeta', data)

      return data
    },

    openPopup: ({ commit, dispatch }, popup) => {
      commit('openPopup', popup)
      commit('block')

      Tween.to(window, 0.3, {
        scrollTo: {
          y: 0,
          autoKill: false
        },
        ease: Power1.easeOut,
        onComplete: () => {
          commit('unblock')
          dispatch('blockScreen')
        }
      })
    },

    closePopup: ({ commit, dispatch }, routeChanged) => {
      commit('closePopup', routeChanged)
      commit('unblock')
      dispatch('unblockScreen')
    },

    blockScreen: ({ state }) => {
      document.documentElement.style.height = state.window.height + 'px'
      document.body.style.height = state.window.height + 'px'
      document.documentElement.style.overflow = 'hidden'
      document.body.style.height = 'hidden'
    },

    unblockScreen: () => {
      document.documentElement.removeAttribute('style')
      document.body.removeAttribute('style')
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/app.js